import { Box, Button, Dialog, Slide, Typography } from "@mui/material";
import React, { useState } from "react";
import { FormattedMessage } from "react-intl";
import { FacebookIcon, FacebookShareButton, TwitterIcon, TwitterShareButton } from "react-share";
import moment from "moment";
import IconContinue from "../../../../../public/assets/icons/IconContinue";
import IconRedo from "../../../../../public/assets/icons/IconRedo";
import IconShare from "../../../../../public/assets/icons/IconShare";
import IconExam from "../../../../../public/assets/icons/IconExam";
import PaperPlaneTilt from "../../../../../public/assets/icons/PaperPlaneTilt";
import CountdownStartTime from "./CountdownStartTime";
import AnswerBoard from "./AnswerBoard";
import XCircle from "../../../../../public/assets/icons/XCircle";
import FormatTimePractice from "./FormatTimePractice";

const Transition = React.forwardRef((props: any, ref: any) => {
  return (
    // eslint-disable-next-line react/no-children-prop
    <Slide children={props.children} direction="up" ref={ref} {...props} />
  );
});

export default function HeaderQuizResponsive({
  progress,
  quizInfoStart,
  setOpenSubmitDialog,
  checkCountResult,
  answerTotal,
  isShowContinueButton,
  startTime,
  endTime,
  continueFunction,
  redoFunction,
  setOpenAlertDialogTimeOut,
  setOpenResultDialog,
  quizDetail,
  arrayQuizData,
  chooseAnswerOfOneAnswerQuestion,
  chooseAnswerOfManyAnswerQuestion,
  isArena
}) {
  const [openListAnswer, setOpenListAnswer] = useState(false);
  const [isShare, setIsShare] = useState<any>();
  return (
    <div>
      <Box className="sm:w-screen bg-white flex justify-around pt-4 pb-6 border-b border-gray rounded-t-[6px] px-2">
        {!progress ? (
          <>
            <Box
              className="center-row text-[13px] font-[500] text-green"
              style={{
                height: 40,
                borderRadius: 6,
                background: "white",
                width: 100
              }}
              mx={1}
            >
              {startTime &&
                (quizInfoStart?.time > 0 ? (
                  <CountdownStartTime
                    endTime={endTime}
                    startTime={startTime}
                    quizTime={quizInfoStart?.time}
                    onComplete={() => setOpenAlertDialogTimeOut(true)}
                    isArena={isArena}
                    isQuizTime
                    isIpad
                  />
                ) : (
                  <FormatTimePractice time={moment().unix() - moment(startTime).unix()} isIpad />
                ))}
            </Box>
            <Box
              className="center-row"
              onClick={() => {
                setOpenListAnswer(true);
              }}
            >
              <IconExam />
              <Typography className="center-row text-[13px] font-[500] text-green ml-[6px]">
                {checkCountResult(answerTotal)}/{quizInfoStart?.question_ids?.length || 0}
              </Typography>
            </Box>
            <Box
              className="center-row"
              style={{
                width: 113,
                height: 40,
                background: "linear-gradient(180deg, #FEDF3F 0%, #F7871D 100%)",
                borderRadius: 6
              }}
              onClick={() => {
                setOpenSubmitDialog(true);
              }}
            >
              <PaperPlaneTilt />
              <span className="text-white ml-2 font-[500] text-[13px]">
                <FormattedMessage id="Question.submit" />
              </span>
            </Box>
          </>
        ) : (
          <>
            <Button
              className="border border-gray"
              variant="outlined"
              size="medium"
              style={{
                height: 40,
                borderRadius: 16,
                textTransform: "none"
              }}
              onClick={() => {
                setOpenResultDialog(true);
              }}
              startIcon={<IconExam />}
            >
              <span className="text-blackQuiz">
                <FormattedMessage id="QuestionResult.title" />
              </span>
            </Button>
            {!isArena && (
              <Button
                className="border-gray border text-blackQuiz"
                variant="outlined"
                size="medium"
                style={{
                  height: 40,
                  borderRadius: 16,
                  textTransform: "none",
                  fontWeight: 500
                }}
                startIcon={<IconRedo width={20} height={20} />}
                onClick={() => {
                  redoFunction();
                  window.scrollTo(0, 0);
                }}
              >
                <span className="text-blackQuiz">
                  <FormattedMessage id="QuestionResult.redo" />
                </span>
              </Button>
            )}

            {isShowContinueButton ? (
              <Button
                variant="outlined"
                size="medium"
                className="border-gray border text-blackQuiz"
                style={{
                  height: 40,
                  borderRadius: 16,
                  textTransform: "none",
                  fontWeight: 500
                }}
                startIcon={<IconContinue width={20} height={20} />}
                onClick={() => {
                  continueFunction();
                  window.scrollTo(0, 0);
                }}
              >
                <span>
                  <FormattedMessage id="common.continue" />
                </span>
              </Button>
            ) : (
              <Box>
                <Button
                  className="border-gray border"
                  variant="outlined"
                  style={{
                    height: 40,
                    borderRadius: 16,
                    textTransform: "none"
                  }}
                  onClick={() => setIsShare(!isShare)}
                  startIcon={<IconShare width={20} height={20} />}
                >
                  <span className="text-blackQuiz">
                    <FormattedMessage id="QuestionResult.share" />
                  </span>
                </Button>
                {isShare && (
                  <Box display="flex" mt={1}>
                    <FacebookShareButton url={window.location.href}>
                      <FacebookIcon size={32} round />
                    </FacebookShareButton>
                    &nbsp; &nbsp;
                    <TwitterShareButton url={window.location.href}>
                      <TwitterIcon size={32} round />
                    </TwitterShareButton>
                  </Box>
                )}
              </Box>
            )}
          </>
        )}
      </Box>

      {openListAnswer && (
        <Dialog fullScreen open={openListAnswer} TransitionComponent={Transition}>
          <button
            type="button"
            onClick={() => setOpenListAnswer(false)}
            style={{
              position: "absolute",
              right: 4,
              top: 4,
              background: "white"
            }}
          >
            <XCircle />
          </button>
          <div className="mt-4">
            <AnswerBoard
              checkCountResult={checkCountResult}
              quizInfoStart={quizInfoStart}
              answerTotal={answerTotal}
              startTime={startTime}
              quizDetail={quizDetail}
              endTime={endTime}
              isArena={isArena}
              setOpenAlertDialogTimeOut={setOpenAlertDialogTimeOut}
              arrayQuizData={arrayQuizData}
              chooseAnswerOfOneAnswerQuestion={chooseAnswerOfOneAnswerQuestion}
              chooseAnswerOfManyAnswerQuestion={chooseAnswerOfManyAnswerQuestion}
              setOpenSubmitDialog={setOpenSubmitDialog}
              scrollFunc={() => {}}
              isDialog
            />
          </div>
        </Dialog>
      )}
    </div>
  );
}
